document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth <= 767) { // Apply only for mobile
        const stickyAtc = document.getElementById('atc-sticky');
        const originalAtc = document.getElementById('atc-original');

        let isStickyVisible = false; // Track sticky visibility state

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.boundingClientRect.bottom > 0) {
                    // Original ATC is in or below the viewport, hide sticky button
                    if (isStickyVisible) {
                        stickyAtc.classList.remove('sticky');
                        isStickyVisible = false;
                    }
                } else if (!isStickyVisible) {
                    // Original ATC is fully out of the viewport (above), show sticky button
                    stickyAtc.classList.add('sticky');
                    isStickyVisible = true;
                }
            });
        }, {
            threshold: 0, // Trigger as soon as the ATC leaves or enters
        });

        observer.observe(originalAtc);
    }
});